import { Button } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import userApi from 'src/api/userApi'
import { TeacherCharacteristic } from 'src/components/assign-class/regular/scheduling/data/common'
import { CategoryColumn } from 'src/components/common/CategoryColumn'
import { Table } from 'src/components/common/table'
import { useGetCategoryOptions } from 'src/hooks/useGetCategoryOptions'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { CATEGORY_TYPE, URL_TEMPLATE } from 'src/libs/constant'
import { getFullName } from 'src/libs/util'
import Link from 'next/link'
import { keyBy } from 'lodash'
import {
  TeacherGrade,
  TeacherHireDate,
  TeacherLevel
} from 'src/components/assign-class/makeup-lesson/scheduling/data/common'

export function TeacherTable ({
  paginatedData,
  teacherClassify,
  setTeacherSchedule,
  handleClose,
  ...rest
}) {
  const { t } = useTranslation()
  const teacherClassifyById = teacherClassify?.content ? keyBy(teacherClassify?.content, 'id') : []

  const violationLevelOptions = useGetCategoryOptions(CATEGORY_TYPE.VIOLATION_LEVEL)
  const columns = useMemo(() => {
    return [
      {
        title: t('page.class.label.teacher'),
        width: 200,
        render (_, record) {
          const { teacherId, teacherUsername } = record
          const { data: teacher } = useGetWithContext(
            `GET_TEACHER_DETAIL_BY_ID${teacherId}`,
            userApi.detailTeacher,
            teacherId,
            { isDisabled: !teacherId }
          )
          if (!teacher) return null
          const fullName = getFullName(teacher)
          return (
            <>
              <Link href={`${URL_TEMPLATE.MANAGE_USER_DETAIL}?id=${teacherId}`}>
                <a target='_blank'>{fullName}</a>
              </Link>
              <span className='d-block'>Code: {teacherUsername}</span>
            </>
          )
        }
      },
      {
        title: t('page.class.label.base_info'),
        width: '250px',
        render (_, record) {
          const { teacherId, regionIds, teacherClassifyIds } = record
          const { data: teacher } = useGetWithContext(
            `GET_TEACHER_DETAIL_BU_ID${teacherId}`,
            userApi.detailTeacher,
            teacherId,
            { isDisabled: !teacherId }
          )
          if (!teacher) return null
          const { gender, teacherInfo } = teacher

          const { certificate, certificateNote } = teacherInfo || {}
          const _certificate = certificate ? JSON.parse(certificate) : []

          return (
            <>
              <span>
                {t('page.class.label.region')}: &nbsp;
                {!!regionIds?.length && (
                  <CategoryColumn
                    type={CATEGORY_TYPE.REGION}
                    id={regionIds[0]}
                  />
                )}
              </span>
              <br />
              <span>
                {t('page.class.label.gender')}: &nbsp;
                {gender && t(`constant.gender.${gender}`)}
              </span>
              <br />
              <>
                {t('page.class.label.certificate')}: &nbsp;
                {
                  _certificate.length ? _certificate.map(item => {
                    return `${t(`constant.certificate.${item}`)}`
                  }).join(', ') : ''
                } {certificateNote}
              </>
              <br />
              <span className='d-block'>
                {t('page.teacher.text.tutor_file')}: &nbsp;
                {teacherClassifyIds?.map(item => teacherClassifyById[item]?.name).join(', ')}
              </span>
            </>
          )
        }
      },
      {
        title: t('page.user.label.teaching_information'),
        width: '300px',
        render (_, record) {
          const {
            grades,
            teacherLevelId,
            density,
            densityRate,
            proportion,
            hireDate,
            gradePriorities,
            violationLevelId
          } = record
          return (
            <>
              <TeacherLevel
                teacherLevelId={teacherLevelId}
                density={density}
                densityRate={densityRate}
                proportion={proportion}
              />
              <TeacherGrade
                grades={grades}
                gradePriorities={gradePriorities}
              />
              <TeacherHireDate hireDate={hireDate} />
              <span className='d-block'>
                {t('page.teacher.text.violation_level')}: &nbsp;
                {violationLevelOptions?.find(item => item.value === violationLevelId)?.label}
              </span>
            </>
          )
        }
      },
      {
        title: t('page.class.label.teacher_characteristic'),
        render (_, record) {
          return <TeacherCharacteristic teacherId={record.teacherId} />
        }
      },
      {
        title: t('page.class.label.action'),
        width: '120px',
        render (_, record) {
          const handleAction = () => {
            setTeacherSchedule(record)
            handleClose()
          }
          return <Button onClick={handleAction} type='primary'>{t('common.label.select')}</Button>
        }
      }
    ]
  }, [])

  return (
    <Table
      paginatedData={paginatedData}
      columns={columns}
      className='table-custom'
      {...rest}
      disableShowTotal
    />
  )
}
